import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, fromEvent, tap } from 'rxjs';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { TkValidator } from 'src/app/validator/tk.validator';

@Component({
  selector: 'app-financial-document',
  templateUrl: './financial-document.component.html',
  styleUrl: './financial-document.component.scss'
})
export class FinancialDocumentComponent {
  @ViewChild('searchOption') searchOption: ElementRef;
  company_name: any;
  public financialForm: UntypedFormGroup;
  companyList: any;
  searchQuery = '';
  note = false;
  selectedCompany: any;
  companyData: any;
  ayList = [];
  selectedYear: any;
  selectedProductArray: any;
  productList: any[];
  totalPrice: number;
  ayArray=[];
  loginEmail: string;
  showReport = false;
  showDoc = false;
  isComprehensiveChecked = false;
  isFinancialChecked = false;
  financial: boolean;
  doublePrice=0;
  company: any;



  constructor(private companyService: CompanyService,
    private route: ActivatedRoute,
    private router : Router,
    private commonService: CommonService,
    private tansactionService: TansactionService,
    private localStorage: LocalStorageService,
    private loginSignupService: LoginSignupService,
    private toastService: ToastService,) {

    this.financialForm = new UntypedFormGroup({
      company_name: new UntypedFormControl('', [Validators.required]),
      website: new UntypedFormControl('',[TkValidator.url]),
      cin: new UntypedFormControl('',[Validators.minLength(21)]),
      name: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      contact: new UntypedFormControl('',[ Validators.minLength(10),
        Validators.maxLength(10),
        TkValidator.numberOnly,
        TkValidator.noWhiteSpace,]),
      tc: new UntypedFormControl(false, [Validators.requiredTrue]),
      balanceSheet: new UntypedFormControl([]),
      profitLossSheet : new UntypedFormControl([]),
      company_report: new UntypedFormControl(''),
      financial_comparison: new UntypedFormControl(''),
      financial_report: new UntypedFormControl(''),
      financial_ratio: new UntypedFormControl(''),
      revenue_report: new UntypedFormControl(''),
      expense_report: new UntypedFormControl(''),

    });
    this.company_name = this.localStorage.getItem("companyName-DNF");
    this.getCompanyData();
  }

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;   
    console.log(this.loginEmail)
  }

  getCompanyData(){
    let requestData = {
      textSearch: this.company_name,
    };
    this.commonService
      .searchOptionList(requestData)
      .then((data: any) => {
        if (data.data.length > 0) {
          this.companyList = data.data; 
          if(this.companyList.length == 1){
            this.company = this.companyList[0]
          }
      
          this.searchOption.nativeElement.value = this.company_name;
          this.financialForm.patchValue({ 
            company_name: this.company_name,
            cin: this.company.cin,
            website: this.company.website });  
            this.showReport = true; 
            this.companyList = []
            this.getHistoricalData(this.company.cin);
        } else {
          this.showDoc = true;
          this.financialForm.get('company_report').setValue(true);
          this.totalPrice = 1999;
          this.companyList = undefined;
          this.searchOption.nativeElement.value = this.company_name;
          this.financialForm.patchValue({ 
            company_name: this.company_name,
          })
          this.note = true;
        }
      })
      .catch((err: any) => {
        console.log(err)
        this.companyList = undefined;
      });
  }

  
  onBalanceSheetCheckboxChange(): void {
    const isChecked = (document.getElementById('balsheet') as HTMLInputElement).checked;
    const ayValues = this.getAyListValues();

    if(this.isComprehensiveChecked || this.isFinancialChecked){
      ayValues.pop();
    }

    if (isChecked) {
      this.financialForm.controls['balanceSheet'].setValue(ayValues);
      this.financialForm.controls['profitLossSheet'].setValue(ayValues);
      (document.getElementById('pl') as HTMLInputElement).checked = true;
      if(this.isComprehensiveChecked || this.isFinancialChecked){
        (document.getElementById('fs') as HTMLInputElement).checked = false;
      }else{
        (document.getElementById('fs') as HTMLInputElement).checked = true;
      }
    } else {
      this.financialForm.controls['balanceSheet'].setValue([]);
      this.financialForm.controls['profitLossSheet'].setValue([]);
      (document.getElementById('pl') as HTMLInputElement).checked = false;
      (document.getElementById('fs') as HTMLInputElement).checked = false;
    }
    this.calculateTotalPrice();
  }

  private getAyListValues(): any[] {
    return this.ayList.map(item => item.value);
  }

  onProfitLossCheckboxChange(): void {
    let isChecked = (document.getElementById('pl') as HTMLInputElement).checked;
    let ayValues = this.getAyListValues();
    if(this.isComprehensiveChecked || this.isFinancialChecked){
      ayValues.pop();
    }
    if (isChecked) {

      this.financialForm.controls['balanceSheet'].setValue(ayValues);
      this.financialForm.controls['profitLossSheet'].setValue(ayValues);
      (document.getElementById('balsheet') as HTMLInputElement).checked = true;
      if(this.isComprehensiveChecked || this.isFinancialChecked){
        (document.getElementById('fs') as HTMLInputElement).checked = false;
      }else{
        (document.getElementById('fs') as HTMLInputElement).checked = true;
      }
    } else {
      this.financialForm.controls['balanceSheet'].setValue([]);
      this.financialForm.controls['profitLossSheet'].setValue([]);
      (document.getElementById('balsheet') as HTMLInputElement).checked = false ;
      (document.getElementById('fs') as HTMLInputElement).checked =  false;
    }
    this.calculateTotalPrice();
  }

  onFinancialStatementCheckboxChange(): void {
    const financialStatementCheckbox = (document.getElementById('fs') as HTMLInputElement).checked;
    const ayValues = this.getAyListValues();
    if(this.isComprehensiveChecked || this.isFinancialChecked){
      (document.getElementById('fs') as HTMLInputElement).checked = false;
    }else{
      if (financialStatementCheckbox) {
        this.financialForm.controls['balanceSheet'].setValue(ayValues);
        this.financialForm.controls['profitLossSheet'].setValue(ayValues);
        (document.getElementById('pl') as HTMLInputElement).checked = true;
        (document.getElementById('balsheet') as HTMLInputElement).checked = true 
      } else {
        this.financialForm.controls['balanceSheet'].setValue([]);
        this.financialForm.controls['profitLossSheet'].setValue([]);
        (document.getElementById('balsheet') as HTMLInputElement).checked = false ;
        (document.getElementById('pl') as HTMLInputElement).checked = false;
      }
    }
    this.calculateTotalPrice();
  }

  onBalanceSheetMultiSelectChange(event): void {
    const selectedValues = event.value;
    if(this.isComprehensiveChecked || this.isFinancialChecked){
      selectedValues.pop();
    }
    this.financialForm.get('balanceSheet').setValue(selectedValues);
    if (selectedValues.length > 0 ) {
      this.financialForm.get('profitLossSheet').setValue(selectedValues);
      this.setCheckboxes(true);
    }else{
      this.financialForm.get('profitLossSheet').setValue(selectedValues);
      this.setCheckboxes(false);
    }
    if(this.ayList.length !== selectedValues.length){
      (document.getElementById('fs') as HTMLInputElement).checked = false;
    }
    if(this.ayList.length == selectedValues.length){
      (document.getElementById('fs') as HTMLInputElement).checked = true;
    }
    this.calculateTotalPrice();
  }

  onProfitLossMultiSelectChange(event): void {
    const selectedValues = event.value;
    if(this.isComprehensiveChecked || this.isFinancialChecked){
      selectedValues.pop();
    }
    this.financialForm.get('profitLossSheet').setValue(selectedValues);
    if (selectedValues.length > 0) {
      this.financialForm.get('balanceSheet').setValue(selectedValues);
      this.setCheckboxes(true);
    }else{
      this.financialForm.get('balanceSheet').setValue(selectedValues);
      this.setCheckboxes(false);
    }
    if(this.ayList.length !== selectedValues.length){
      (document.getElementById('fs') as HTMLInputElement).checked = false;
    }

    if(this.ayList.length == selectedValues.length){
      (document.getElementById('fs') as HTMLInputElement).checked = true;
    }
    this.calculateTotalPrice();
  }

  setCheckboxes(checked: boolean): void {
    (document.getElementById('balsheet') as HTMLInputElement).checked = checked;
    (document.getElementById('pl') as HTMLInputElement).checked = checked;
  }

 
  private lastValueRemoved = false; // Track if last value has been removed

  onComprehensiveChange(event: any) {
    this.isComprehensiveChecked = event.target.checked;
    this.financialForm.get('company_report').setValue(true);
    let balanceSheetValues = this.financialForm.get('balanceSheet').value;
    let profitLossValues = this.financialForm.get('profitLossSheet').value;
  
    // If Comprehensive Report is checked
    if (this.isComprehensiveChecked) {
      // Remove the last value in both balance sheet and profit loss if they exist and not already removed
      if(balanceSheetValues.length == this.ayList.length){
        this.lastValueRemoved = false;
      }
      if (!this.lastValueRemoved) {
        if (balanceSheetValues.length > 0) {
          balanceSheetValues = balanceSheetValues.slice(0, -1);
        }
        if (profitLossValues.length > 0) {
          profitLossValues = profitLossValues.slice(0, -1);
        }
        
        // Set the flag to true after removing the last value
        this.lastValueRemoved = true;
      }
  
      // Update the form controls with the modified values (without the last value)
      this.financialForm.get('balanceSheet').setValue(balanceSheetValues);
      this.financialForm.get('profitLossSheet').setValue(profitLossValues);
  
      this.financialForm.get('financial_report').setValue(true);
      this.financialForm.get('financial_comparison').setValue(true);
      this.financialForm.get('financial_ratio').setValue(true);
      this.financialForm.get('revenue_report').setValue(true);
      this.financialForm.get('expense_report').setValue(true);
      this.calculateTotalPrice();
    } else {
      // When the checkbox is unchecked, reset the removal flag
      this.financialForm.get('company_report').setValue(false);
      this.financialForm.get('financial_report').setValue(false);
      this.financialForm.get('financial_comparison').setValue(false);
      this.financialForm.get('financial_ratio').setValue(false);
      this.financialForm.get('revenue_report').setValue(false);
      this.financialForm.get('expense_report').setValue(false);
      this.totalPrice -= 1999; 
    }
  
    // Ensure that the financial statement checkbox is unchecked
    (document.getElementById('fs') as HTMLInputElement).checked = false;
  }
  

  onFinancialChange(event: any) {
    this.isFinancialChecked = event.target.checked;
    this.financialForm.get('financial_report').setValue(true);
    let balanceSheetValues = this.financialForm.get('balanceSheet').value;
    let profitLossValues = this.financialForm.get('profitLossSheet').value;
    if (this.isFinancialChecked) {
      this.isComprehensiveChecked = false;
      this.financialForm.get('financial_comparison').setValue(true);
      this.financialForm.get('financial_ratio').setValue(true);
      this.financialForm.get('revenue_report').setValue(true);
      this.financialForm.get('expense_report').setValue(true);
    
      if(balanceSheetValues.length == this.ayList.length){
        this.lastValueRemoved = false;
      }
      if (!this.lastValueRemoved) {
        if (balanceSheetValues.length > 0) {
          balanceSheetValues = balanceSheetValues.slice(0, -1);
        }
        if (profitLossValues.length > 0) {
          profitLossValues = profitLossValues.slice(0, -1);
        }
        
        // Set the flag to true after removing the last value
        this.lastValueRemoved = true;
      }
  
      // Update the form controls with the modified values (without the last value)
      this.financialForm.get('balanceSheet').setValue(balanceSheetValues);
      this.financialForm.get('profitLossSheet').setValue(profitLossValues);
      this.calculateTotalPrice();
    }else{
      this.financialForm.get('financial_report').setValue(false);
      this.financialForm.get('financial_comparison').setValue(false);
      this.financialForm.get('financial_ratio').setValue(false);
      this.financialForm.get('revenue_report').setValue(false);
      this.financialForm.get('expense_report').setValue(false);
      this.totalPrice -= 799; 
    }
    (document.getElementById('fs') as HTMLInputElement).checked = false;
  }

  shouldDisableOtherCheckboxes(): boolean {
    return this.isComprehensiveChecked;
  }

  disabledFinancial(): boolean {
    return this.isFinancialChecked;
  }

  search(event) {
   if (this.searchOption.nativeElement.value.length > 0) {
      fromEvent(this.searchOption.nativeElement, 'keyup')
        .pipe(
          filter(Boolean),
          debounceTime(150),
          distinctUntilChanged(),
          tap((event: KeyboardEvent)  => {
            if (this.searchOption.nativeElement.value != this.searchQuery) {
              this.searchQuery = this.searchOption.nativeElement.value;
              let requestData = {
                textSearch: this.searchOption.nativeElement.value,
              };
              this.commonService
                .searchOptionList(requestData)
                .then((data: any) => {
                  if (data.data.length > 0) {
                    this.companyList = data.data;
                  } else {
                    this.companyList = undefined;
                  }
                })
                .catch((err: any) => {
                  console.log(err)
                  this.companyList = undefined;
                });
            }
          })
        )
        .subscribe();
    } else {
      this.companyList = undefined;
    }
  }

  searchDataValue(companyInfo: any) {
    this.companyList = [];
    this.selectedCompany = companyInfo;
    this.searchOption.nativeElement.value = companyInfo.name;
    this.company_name = companyInfo.name;
    this.getCompanyData();
  }

  getHistoricalData(cin) {
    let request = { cin };
    this.companyService
      .getCompanyHistoricalDetails(request)
      .then((data: any) => {
        if (data.message) {
          this.toastService.addSingle('error', 'Error', data.message);
        } else {
          this.companyData = data;
          let initialValue = {};

          this.companyData['roc_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'ROC'
            );
          this.companyData['pls_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'PLS'
            );
          this.companyData['bss_product_list'] =
            this.companyData.product_list_arr.filter(
              (item) => item.type === 'BSS'
            );
          this.companyData.product_list =
            this.companyData.product_list_arr.filter(
              (item) =>
                item.type !== 'BSS' &&
                item.type !== 'ROC' &&
                item.type !== 'PLS'
            );

          this.companyData.product_list = this.companyData.product_list.reduce(
            (obj, item) => {
              return {
                ...obj,
                [item['type']]: item,
              };
            },
            initialValue
          );
          this.generateUnique(this.companyData.pls_product_list);
          this.generateUnique(this.companyData.bss_product_list);
          if(this.ayArray.length > 0){
            this.ayArray.sort(function (a, b) {
              return a.substring(0, 4) - b.substring(0, 4);
            });
            this.ayArray = this.ayArray.slice(-3);
            this.ayList = this.ayArray.map(ay => ({
              label: ay,
              value: ay
            }));
          }
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  generateUnique(list) {
    list.forEach((product) => {
      if (product.enable && !this.ayArray.includes(product.ay)) {
        this.ayArray.push(product.ay);
      }
    });
  }

  submit(){
    const itemArray = [
      { type: 'balanceSheet', value: this.financialForm.value.balanceSheet },
      { type: 'profitLossSheet', value: this.financialForm.value.profitLossSheet },
      { type: 'company_report', value: this.financialForm.value.company_report },
      { type: 'financial_comparison', value: this.financialForm.value.financial_comparison },
      { type: 'financial_report', value: this.financialForm.value.financial_report },
      { type: 'financial_ratio', value: this.financialForm.value.financial_ratio },
      { type: 'revenue_report', value: this.financialForm.value.revenue_report },
      { type: 'expense_report', value: this.financialForm.value.expense_report }
    ];
    if(this.loginEmail !== undefined && this.loginEmail !== '' && this.loginEmail !== null){
      this.financialForm.patchValue({ 
        email: this.loginSignupService.getUserSession()?.user?.email,
        name: this.loginSignupService.getUserSession()?.user?.name,
      });  
      const formValues = this.financialForm.getRawValue();
      const formData = {
        ...formValues, 
        price: this.totalPrice,
        item: itemArray
      };
      this.companyService.downloadFinancialRequest(formData).then(
        (data: any) => {
          this.addToCart(data.product.sku)
        },
        (err) => { }
      );
    }else{
      if(this.financialForm.value.email == null || this.financialForm.value.email == '' || this.financialForm.value.email == undefined){
        this.toastService.addSingle( 'error',
              'Error','Email is required. Please provide an email address.');
        return;
      }
      if(this.financialForm.value.name == null || this.financialForm.value.name == '' || this.financialForm.value.name == undefined){
        this.toastService.addSingle( 'error',
              'Error','Name is required. Please provide an name.');
        return;
      }
      if(this.financialForm.value.contact == null || this.financialForm.value.contact == '' || this.financialForm.value.contact == undefined){
        this.toastService.addSingle( 'error',
              'Error','Contact is required. Please provide an contact address.');
        return;
      }
      let formData ={
        email: this.financialForm.value.email,
        role : "guest",
        name : this.financialForm.value.name,
        mobile : this.financialForm.value.contact,
      }
      this.loginSignupService.createGuestUser(formData).then(
        (data: any) => {
          console.log(data)
          if(data.message == "User found" && data.user.role != "guest"){
            this.toastService.addSingle(
              'error',
              'Error',
              "It looks like you're already a registered user with us. Please log in to continue."
            );
          }else{
            this.loginSignupService.setGuestUserData(data);
            const formValues = this.financialForm.getRawValue();
            const formData = {
              ...formValues, 
              price: this.totalPrice,
              item: itemArray
            };
            this.companyService.downloadFinancialRequest(formData).then(
              (data: any) => {
                  if (data.product) {
                    this.addToCart(data.product.sku)
                  }
              },
              (err) => { }
            );
          }
        },
        (err) => { }
      );
    }
  }

  onOptionsSelected(year) {
    this.selectedYear = year;
    this.updateProductList();
  }

  updateProductSelection(product) {
    const index = this.selectedProductArray.indexOf(product);

    if (index > -1) {
      this.selectedProductArray.splice(index, 1);
    } else {
      this.selectedProductArray.push(product);
    }
    this.updateProductList();
  }

  updateProductList() {
    this.productList = [];
    this.totalPrice = 0;
    if (this.selectedProductArray.includes('pls')) {
      this.productList.push(
        ...this.companyData.pls_product_list.filter((product) => {
          return product.ay === this.selectedYear;
        })
      );
    }
    if (this.selectedProductArray.includes('bss')) {
      this.productList.push(
        ...this.companyData.bss_product_list.filter((product) => {
          return product.ay === this.selectedYear;
        })
      );
    }
    this.productList.forEach((product) => {
      this.totalPrice += product.price;
    });
  }


  async addToCart(sku) {
      let currentOption;
      currentOption = {
        sku: sku,
      };
      try {
        const data: any = await this.tansactionService.addProductToCart(currentOption);
        this.toastService.addSingle(
          'success',
          'Item added to cart',
          'Make payment to complete this transaction.'
        );
        this.localStorage.removeItem("companyName-DNF")
        this.router.navigate(['/cart']);
      } catch (err) {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
  }

  getValuesForProduct(item) {
    const companyReport = item.find((i: any) => i.type === 'company_report' && i.value === true);
    const balanceSheet = item.find((i: any) => i.type === 'balanceSheet');
    const financialReport = item.find((i: any) => i.type === 'financial_report' && i.value === true);

    let data;
    let price = 0;

    // Check if all required reports (excluding balanceSheet and profitLossSheet) are selected
    const allReportsSelected = item.every((i: any) => {
      return (i.type !== 'balanceSheet' && i.type !== 'profitLossSheet') ? i.value === true : true;
    });

    // Pricing logic based on the length of balance sheet values
    if (balanceSheet) {
      const balanceSheetLength = balanceSheet.value.length;

      if (balanceSheetLength === 1) {
        price = 199; // Price for 1 year
      } else if (balanceSheetLength === 2) {
        price = 199 * 2; // Price for 2 years
      } else if (balanceSheetLength === 3) {
        price = 499; // Price for 3 years
      }
    }

    // If all required reports are selected
    if (allReportsSelected) {
      price += 1999; // Add to price
    }
    // If the company report is selected but not all others
    else if (companyReport) {
      price += 1999; // Set price for company report
    } else if (financialReport) {
      price += 799; // Price for financial report
    }
    // Pricing and description for specific reports
    else{
    const selectedReports = item.filter((i: any) => i.value === true && i.type !== 'balanceSheet' && i.type !== 'profitLossSheet');

    // Add pricing for financial_ratio and financial_comparison
    selectedReports.forEach(report => {
        switch (report.type) {
            case 'financial_comparison':
                price += 430; // Price for financial comparison
                break;
            case 'financial_ratio':
                price += 199; // Price for financial ratio
                break;
            case 'revenue_report':
                price += 399; // Price for revenue report
                break;
            case 'expense_report':
                price += 399; // Price for expense report
                break;
            // Add more cases as needed for other reports
            default:
                break;
        }
    });
  }
    data = {
      price: price
    };

    return data;
  }

  onFinancialExpenseChange(event){
    if(this.isComprehensiveChecked){
      this.financialForm.get('expense_report').setValue(true);
    }else if(this.isFinancialChecked){
      this.financialForm.get('expense_report').setValue(true);
    }
    this.calculateTotalPrice();
  }

  onFinancialRevenueChange(event){
    if(this.isComprehensiveChecked){
      this.financialForm.get('revenue_report').setValue(true);
    }else if(this.isFinancialChecked){
      this.financialForm.get('revenue_report').setValue(true);
    }
    this.calculateTotalPrice();
  }

  onFinancialRatioChange(event){
    if(this.isComprehensiveChecked){
      this.financialForm.get('financial_ratio').setValue(true);
    }else if(this.isFinancialChecked){
      this.financialForm.get('financial_ratio').setValue(true);
    }
    this.calculateTotalPrice();
  }

  onFinancialComparisonChange(event){
    if(this.isComprehensiveChecked){
      this.financialForm.get('financial_comparison').setValue(true);
    }else if(this.isFinancialChecked){
      this.financialForm.get('financial_comparison').setValue(true);
    }
    this.calculateTotalPrice();
  }


  calculateTotalPrice() {
    const allReports = [
      { type: 'company_report', value: this.financialForm.get('company_report').value },
      { type: 'balanceSheet', value: this.financialForm.get('balanceSheet').value },
      { type: 'profitLossSheet', value: this.financialForm.get('profitLossSheet').value },
      { type: 'financial_report', value: this.financialForm.get('financial_report').value },
      { type: 'financial_comparison', value: this.financialForm.get('financial_comparison').value },
      { type: 'financial_ratio', value: this.financialForm.get('financial_ratio').value },
      { type: 'revenue_report', value: this.financialForm.get('revenue_report').value },
      { type: 'expense_report', value: this.financialForm.get('expense_report').value },
    ];

    const { price } = this.getValuesForProduct(allReports);
    this.totalPrice = price;
  }

}
